import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Technician } from '../state-man/models/technician.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class TechnicianService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: Technician[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('user/technicians/', version)
      return ret && { version: ret.version, rows: ret.rows && Technician.buildMany(ret.rows) }
    } 
    catch (error) {    
      LoggerService.log(error + 'user/technicians/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')      
      return null
    }
  }  
  
}
